import lightbox from '../modules/lightbox';

const stopMarkerEvents = (event) => {
	// If it's a link
	if (event.target.matches('a')) {
		event.stopPropagation();
	}

	// If it's a close icon
	if (event.target.matches('.icon-close')) {
		event.stopPropagation();
	}

	// If it's a close element
	if (event.target.matches('.html-map-marker-popup-close')) {
		event.stopPropagation();
	}

	// If it's a lightbox link
	if (event.target.matches('[data-lightbox]')) {
		event.stopPropagation();
		event.preventDefault();
		lightbox.showHandler(event);
	}
};

export default function htmlMapMarker(HtmlMapMarker) {
	HtmlMapMarker = function (options) {
		//console.log(options);
		this.type = options.type;
		this.html = options.html;
		this.latlng = options.latlng;
		this.data = options.data;
		this.parentMap = options.map;
		this.onPopupClose = options.onPopupClose;
		this.afterRender = options.afterRender ? options.afterRender : () => {};
		this.rendered = false;

		this.setMap(this.parentMap);
	};

	HtmlMapMarker.prototype = new window.google.maps.OverlayView();

	HtmlMapMarker.prototype.draw = function () {
		var self = this;
		var div = this.div;
		if (!div) {
			div = this.div = document.createElement('div');
			div.className = 'html-map-marker';
			div.innerHTML = this.html;
			div.style.position = 'absolute';
			//iv.style.transform = 'translate(-50%, -50%)';
			//div.style.cursor = 'pointer';

			// pass through bindings
			window.google.maps.event.addDomListener(div, 'click', function () {
				window.google.maps.event.trigger(self, 'click');
			});
			window.google.maps.event.addDomListener(div, 'touchend', function () {
				window.google.maps.event.trigger(self, 'click');
			});
			window.google.maps.event.addDomListener(div, 'mouseover', function () {
				window.google.maps.event.trigger(self, 'mouseover');
			});
			window.google.maps.event.addDomListener(div, 'mouseout', function () {
				window.google.maps.event.trigger(self, 'mouseout');
			});

			// add marker to overlay image layer
			var panes = this.getPanes();
			panes.overlayImage.appendChild(div);
			//panes.overlayMouseTarget.appendChild(div);

			// set offset margin to center marker on lat/lng
			div.style.marginTop = -(div.clientHeight / 2) + 'px';
			div.style.marginLeft = -(div.clientWidth / 2) + 'px';
		}
		var point = this.getProjection().fromLatLngToDivPixel(this.latlng);
		if (point) {
			div.style.left = point.x + 'px';
			div.style.top = window.innerWidth < 1200 && this.type !== 'ausStatePills' ? point.y + 120 + 'px' : point.y + 'px';
		}

		if (!this.rendered) {
			this.rendered = true;
			this.afterRender();
		}
	};

	HtmlMapMarker.prototype.openPopup = function (options) {
		if (!this.popup) {
			// setup popup element
			this.popup = document.createElement('div');
			this.popup.className = 'html-map-marker-popup';

			// add custom popup html to popup
			this.popup.innerHTML = options.popupHtml;

			// custom close btn html
			if (options.closeHtml) {
				this.popupClose = document.createElement('div');
				this.popupClose.className = 'html-map-marker-popup-close';
				this.popupClose.innerHTML = options.closeHtml;
				this.popup.appendChild(this.popupClose);

				//binding for close button
				this.popupClose.addEventListener('click', (event) => {
					event.stopPropagation();
					event.preventDefault();
					this.closePopup();
				});
			}

			// disable/enable map scroll on popup hover
			window.google.maps.event.addDomListener(this.popup, 'mouseover', () => {
				this.parentMap.setOptions({ draggable: false, scrollwheel: false });
			});
			window.google.maps.event.addDomListener(this.popup, 'mouseout', () => {
				this.parentMap.setOptions({ draggable: true, scrollwheel: true });
			});
			// touch
			window.google.maps.event.addDomListener(this.popup, 'touchstart', () => {
				this.parentMap.setOptions({ draggable: false, scrollwheel: false });
			});
			window.google.maps.event.addDomListener(this.popup, 'touchend', () => {
				this.parentMap.setOptions({ draggable: true, scrollwheel: true });
			});
			// window.google.maps.event.addDomListener(this.parentMap, 'touchstart', ()=> {
			// 	this.parentMap.setOptions({draggable:true, scrollwheel:true});
			// });

			// add popup to marker
			this.div.style.zIndex = '999';
			this.div.appendChild(this.popup);
			this.div.classList.add('has-popup');

			// stop click events on popup being passed to map data click listeners
			this.popup.addEventListener('touchstart', stopMarkerEvents);
			this.popup.addEventListener('click', stopMarkerEvents);
		}
	};

	HtmlMapMarker.prototype.closePopup = function () {
		if (this.popup) {
			this.div.style.zIndex = 'inherit';
			this.div.removeChild(this.popup);
			this.div.classList.remove('has-popup');
			this.popup = null;
			// re enable map scrolling
			this.parentMap.setOptions({ draggable: true, scrollwheel: true });

			if (this.onPopupClose) {
				this.onPopupClose();
			}
		}
	};

	HtmlMapMarker.prototype.remove = function () {
		this.setMap(null);
		if (this.div) {
			this.div.parentNode.removeChild(this.div);
			this.div = null;
		}
	};

	HtmlMapMarker.prototype.getPosition = function () {
		return this.latlng;
	};

	HtmlMapMarker.prototype.onClick = function (cb) {
		if (this.div) {
			this.div.addEventListener('click', (event) => {
				event.stopPropagation();
				event.preventDefault();
				if (cb) {
					cb();
				}
			});
		}
	};

	return HtmlMapMarker;
}
